const EGYPT_TIME_ZONE = "Africa/Cairo";

export function formatEgyptTime(value: Date | string): string {
  return new Date(value).toLocaleTimeString("ar-EG", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: EGYPT_TIME_ZONE,
  });
}

export function formatEgyptDate(value: Date | string): string {
  return new Date(value).toLocaleDateString("ar-EG", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: EGYPT_TIME_ZONE,
  });
}

export const EGYPT_TZ = EGYPT_TIME_ZONE;

function egyptDateKey(value: Date | string): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: EGYPT_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
}

export function isPublishedTodayInEgypt(value: Date | string | null | undefined, now: Date = new Date()): boolean {
  if (!value) return false;
  const publishedAt = new Date(value);
  if (Number.isNaN(publishedAt.getTime())) return false;
  return egyptDateKey(publishedAt) === egyptDateKey(now);
}

/** Converts an HTML datetime-local value entered as Cairo wall-clock time into UTC. */
export function parseEgyptDateTimeLocal(value: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value);
  if (!match) throw new Error("Invalid Cairo datetime-local value");
  const [, year, month, day, hour, minute] = match;
  const probe = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)));
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: EGYPT_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(probe);
  const part = (type: string) => parts.find((item) => item.type === type)?.value ?? "";
  const asCairoUtc = Date.UTC(Number(part("year")), Number(part("month")) - 1, Number(part("day")), Number(part("hour")), Number(part("minute")));
  const offsetMinutes = Math.round((asCairoUtc - probe.getTime()) / 60000);
  return new Date(probe.getTime() - offsetMinutes * 60000);
}

export function toEgyptDateTimeLocal(value: Date | string): string {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: EGYPT_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(value));
  const part = (type: string) => parts.find((item) => item.type === type)?.value ?? "";
  return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
}
